import axios from '@axios';

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/dmp/templates/get-templates', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    clear({ commit }) {
      commit('setData', [])
    },
    async generateTemplate(_, params) {
      const { data } = await axios.post(`v1/dmp/templates/generate-template`, params)

      return data
    },
    async setTemplate(_, params) {
      const { data } = await axios.post(`v1/dmp/templates/set-template`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/dmp/templates/delete-template/${id}`)

      return data
    },
    async updateTemplate(_, { id, data, template_name, description, config }) {
      const { data: response } = await axios.post('v1/dmp/templates/update-summary', {
        id_template: parseInt(id),
        template_name: template_name ?? '',
        description: description ?? '',
        summary: data,
        config: config ?? {},
      })

      return response
    },
    async createTemplate(_, params) {
      const { data } = await axios.post('v1/dmp/templates/update-summary', params)

      return data
    },
  },
}
